/**
 * Body accessories: vietnamese-bags
 */
import * as THREE from 'three';
import { pickContrastColor } from '../shared.js';

export function buildAcc_ba_lo(lib, accGroup, torsoW, torsoH, torsoD, opts, _handY, _sideX) {
  // Ba lô học sinh / du lịch Voxel: màu chọn tương phản với áo để không "tàng hình" sau lưng
  const bagColor = pickContrastColor(opts.shirtColor || '#ffffff', [
    '#dc2626',
    '#0284c7',
    '#16a34a',
    '#f59e0b',
    '#7c3aed',
    '#1f2937'
  ]);
  const bagMat = new THREE.MeshStandardMaterial({ color: bagColor, roughness: 0.7 });
  const strapMat = new THREE.MeshStandardMaterial({
    color: new THREE.Color(bagColor).multiplyScalar(0.6),
    roughness: 0.8
  });
  const bagGeo = new THREE.BoxGeometry(torsoW * 0.78, torsoH * 0.82, torsoD * 0.6);
  const bag = new THREE.Mesh(bagGeo, bagMat);
  bag.position.set(0, torsoH * 0.5, -torsoD * 0.6);
  bag.castShadow = true;
  accGroup.add(bag);

  // Ngăn phụ bên ngoài
  const pocketGeo = new THREE.BoxGeometry(torsoW * 0.6, torsoH * 0.35, torsoD * 0.22);
  const pocket = new THREE.Mesh(pocketGeo, bagMat);
  pocket.position.set(0, torsoH * 0.35, -torsoD * 0.98);
  accGroup.add(pocket);

  // 2 Quai đeo vai vắt qua ngực phía trước
  [-1, 1].forEach((side) => {
    const strapGeo = new THREE.BoxGeometry(torsoW * 0.18, torsoH * 0.95, 0.02);
    const strap = new THREE.Mesh(strapGeo, strapMat);
    strap.position.set(side * (torsoW * 0.3), torsoH * 0.52, torsoD * 0.51);
    accGroup.add(strap);
    lib.disposables.push(strapGeo);
  });

  lib.disposables.push(bagMat, strapMat, bagGeo, pocketGeo);
}

export function buildAcc_tui_cheo(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // TÚI ĐEO CHÉO / TÚI BAO TỬ ĐẬM CHẤT VOXEL (Thay thế dải nghiêng phẳng bằng dây đai bậc thang Voxel)
  const leatherMat = new THREE.MeshStandardMaterial({ color: '#451a03', roughness: 0.6 });
  const darkMat = new THREE.MeshStandardMaterial({ color: '#1c1917', roughness: 0.8 });
  const zipMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.8, roughness: 0.2 });
  lib.disposables.push(leatherMat, darkMat, zipMat);

  // Thân túi bao tử hình hộp Voxel ôm ngang ngực/hông
  const bagGeo = new THREE.BoxGeometry(torsoW * 0.68, torsoH * 0.32, torsoD * 0.4);
  const bag = new THREE.Mesh(bagGeo, leatherMat);
  bag.position.set(-torsoW * 0.18, torsoH * 0.38, torsoD * 0.54);
  bag.rotation.z = 0.14;
  bag.castShadow = true;
  accGroup.add(bag);

  // Khóa kéo kim loại sáng trên thân túi
  const zipGeo = new THREE.BoxGeometry(torsoW * 0.55, 0.02, 0.015);
  const zip = new THREE.Mesh(zipGeo, zipMat);
  zip.position.set(-torsoW * 0.18, torsoH * 0.44, torsoD * 0.745);
  zip.rotation.z = 0.14;
  accGroup.add(zip);

  // Dây đai liền mạch chạy chéo từ vai phải qua ngực xuống sườn trái (mặt trước & sau lưng)
  const from = new THREE.Vector2(torsoW * 0.4, torsoH * 0.98);
  const to = new THREE.Vector2(-torsoW * 0.36, torsoH * 0.24);
  const strapLen = from.distanceTo(to);
  const strapGeo = new THREE.BoxGeometry(0.045, strapLen, 0.02);
  const strapAngle = Math.atan2(to.x - from.x, from.y - to.y);
  [1, -1].forEach((face) => {
    const strap = new THREE.Mesh(strapGeo, darkMat);
    strap.position.set((from.x + to.x) / 2, (from.y + to.y) / 2, face * torsoD * 0.515);
    strap.rotation.z = strapAngle;
    accGroup.add(strap);
  });
  lib.disposables.push(strapGeo);

  lib.disposables.push(bagGeo, zipGeo);
}

export function buildAcc_cap_tap(lib, accGroup, torsoW, _torsoH, _torsoD, _opts, _handY, _sideX) {
  // CẶP TÁP CÔNG SỞ XÁCH TAY (Voxel Briefcase)
  const briefMat = new THREE.MeshStandardMaterial({ color: '#1c1917', roughness: 0.4 });
  const goldMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.85, roughness: 0.2 });
  const handleMat = new THREE.MeshStandardMaterial({ color: '#292524', roughness: 0.7 });
  lib.disposables.push(briefMat, goldMat, handleMat);

  // Thân cặp táp
  const briefGeo = new THREE.BoxGeometry(0.38, 0.28, 0.12);
  const brief = new THREE.Mesh(briefGeo, briefMat);
  brief.position.set(-torsoW * 0.65, 0.1, 0);
  brief.castShadow = true;
  accGroup.add(brief);

  // Quai xách hình chữ U phía trên
  const handleTopGeo = new THREE.BoxGeometry(0.12, 0.02, 0.02);
  const handleTop = new THREE.Mesh(handleTopGeo, handleMat);
  handleTop.position.set(-torsoW * 0.65, 0.28, 0);
  accGroup.add(handleTop);

  // 2 Khóa bấm kim loại vàng đồng
  [-0.09, 0.09].forEach((xOffset) => {
    const lockGeo = new THREE.BoxGeometry(0.035, 0.05, 0.02);
    const lock = new THREE.Mesh(lockGeo, goldMat);
    lock.position.set(-torsoW * 0.65 + xOffset, 0.12, 0.065);
    accGroup.add(lock);
    lib.disposables.push(lockGeo);
  });

  lib.disposables.push(briefGeo, handleTopGeo);
}

export function buildAcc_vali_keo(lib, accGroup, torsoW, torsoH, torsoD, opts, handY, sideX) {
  // VALI KÉO DU LỊCH CAO CẤP CHUẨN VOXEL (Có rãnh gân nổi 3D, bánh xe xoay, cần kéo chữ U)
  const valiMat = new THREE.MeshStandardMaterial({ color: '#dc2626', roughness: 0.45 });
  const chromeMat = new THREE.MeshStandardMaterial({ color: '#e2e8f0', metalness: 0.9, roughness: 0.15 });
  const blackMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.8 });
  lib.disposables.push(valiMat, chromeMat, blackMat);

  const valiGroup = new THREE.Group();
  valiGroup.position.set(sideX + 0.26, 0, -0.04);
  accGroup.userData.anchor = 'ground';

  // Thân vali chính
  const valiGeo = new THREE.BoxGeometry(0.36, 0.54, 0.24);
  const valiMesh = new THREE.Mesh(valiGeo, valiMat);
  valiMesh.position.y = 0.32;
  valiMesh.castShadow = true;
  valiGroup.add(valiMesh);

  // 3 Rãnh gân dập nổi khí động học mặt trước vali
  [-0.1, 0, 0.1].forEach((yRib) => {
    const ribGeo = new THREE.BoxGeometry(0.3, 0.025, 0.02);
    const rib = new THREE.Mesh(ribGeo, valiMat);
    rib.position.set(0, 0.32 + yRib, 0.125);
    valiGroup.add(rib);
    lib.disposables.push(ribGeo);
  });

  // 4 Cụm bánh xe đôi ở 4 góc đáy
  [
    [-0.13, -0.08],
    [0.13, -0.08],
    [-0.13, 0.08],
    [0.13, 0.08]
  ].forEach(([wx, wz]) => {
    const wheelGeo = new THREE.BoxGeometry(0.045, 0.045, 0.035);
    const wheel = new THREE.Mesh(wheelGeo, blackMat);
    wheel.position.set(wx, 0.025, wz);
    wheel.castShadow = true;
    valiGroup.add(wheel);
    lib.disposables.push(wheelGeo);
  });

  // Cần kéo 2 thanh ray song song mạ kim loại sáng bóng
  const railTop = Math.max(0.75, handY);
  const railLen = railTop - 0.58;
  [-0.07, 0.07].forEach((rx) => {
    const railGeo = new THREE.BoxGeometry(0.02, railLen, 0.02);
    const rail = new THREE.Mesh(railGeo, chromeMat);
    rail.position.set(rx, 0.58 + railLen / 2, -0.08);
    valiGroup.add(rail);
    lib.disposables.push(railGeo);
  });

  // Tay cầm cần kéo chữ U công thái học
  const handleBarGeo = new THREE.BoxGeometry(0.18, 0.03, 0.035);
  const handleBar = new THREE.Mesh(handleBarGeo, blackMat);
  handleBar.position.set(0, railTop + 0.015, -0.08);
  valiGroup.add(handleBar);

  // Quai xách mềm phía trên nóc vali
  const topHandleGeo = new THREE.BoxGeometry(0.14, 0.025, 0.03);
  const topHandle = new THREE.Mesh(topHandleGeo, blackMat);
  topHandle.position.set(0, 0.605, 0);
  valiGroup.add(topHandle);

  accGroup.add(valiGroup);
  lib.disposables.push(valiGeo, handleBarGeo, topHandleGeo);
}

export function buildAcc_thung_hang_shipper(lib, accGroup, torsoW, torsoH, torsoD, _opts, _handY, _sideX) {
  // THÙNG HÀNG GIAO HÀNG SHIPPER / TMĐT CHUẨN VOXEL (Thùng vuông to đeo sau lưng, có quai đeo & phản quang)
  const boxMat = new THREE.MeshStandardMaterial({ color: '#ea580c', roughness: 0.6 });
  const strapMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.8 });
  const stripeMat = new THREE.MeshStandardMaterial({ color: '#f8fafc', roughness: 0.4 });
  const labelMat = new THREE.MeshStandardMaterial({ color: '#fef08a', roughness: 0.9 });
  lib.disposables.push(boxMat, strapMat, stripeMat, labelMat);

  // Thùng hàng chính sau lưng
  const boxGeo = new THREE.BoxGeometry(torsoW * 1.25, torsoH * 1.15, torsoD * 1.1);
  const box = new THREE.Mesh(boxGeo, boxMat);
  box.position.set(0, torsoH * 0.55, -torsoD * 0.92);
  box.castShadow = true;
  accGroup.add(box);

  // Dải phản quang trắng chạy ngang nắp thùng
  const stripeGeo = new THREE.BoxGeometry(torsoW * 1.26, 0.05, torsoD * 1.11);
  const stripe = new THREE.Mesh(stripeGeo, stripeMat);
  stripe.position.set(0, torsoH * 0.92, -torsoD * 0.92);
  accGroup.add(stripe);

  // Nhãn mã vạch / bill giao hàng màu vàng nhạt dán mặt sau
  const labelGeo = new THREE.BoxGeometry(torsoW * 0.55, torsoH * 0.45, 0.02);
  const label = new THREE.Mesh(labelGeo, labelMat);
  label.position.set(0, torsoH * 0.55, -torsoD * 1.48);
  accGroup.add(label);

  // 2 Quai đeo vai to bản vắt qua ngực phía trước
  [-1, 1].forEach((side) => {
    const strapGeo = new THREE.BoxGeometry(torsoW * 0.18, torsoH * 0.98, 0.025);
    const strap = new THREE.Mesh(strapGeo, strapMat);
    strap.position.set(side * (torsoW * 0.32), torsoH * 0.5, torsoD * 0.52);
    accGroup.add(strap);
    lib.disposables.push(strapGeo);
  });

  lib.disposables.push(boxGeo, stripeGeo, labelGeo);
}

export const vietnamese_bags_acc_builders = {
  ba_lo: buildAcc_ba_lo,
  tui_cheo: buildAcc_tui_cheo,
  cap_tap: buildAcc_cap_tap,
  vali_keo: buildAcc_vali_keo,
  thung_hang_shipper: buildAcc_thung_hang_shipper
};
